export const nonFacetSearchParams = [
  {
    paramKey: 'query',
    searchEngineParamKey: 'query',
  },
  {
    paramKey: 'sort',
    searchEngineParamKey: 'sort',
  },
  {
    paramKey: 'startRank',
    searchEngineParamKey: 'start_rank',
  },
  {
    paramKey: 'le_openTimestamp',
    searchEngineParamKey: 'le_openTimestamp',
  },
  {
    paramKey: 'ge_openTimestamp',
    searchEngineParamKey: 'ge_openTimestamp',
  },
  {
    paramKey: 'ge_closeTimestamp',
    searchEngineParamKey: 'ge_closeTimestamp',
  },
  /*{
    paramKey: 'ge_expiryTimestamp',
    searchEngineParamKey: 'ge_expiryTimestamp',
  },*/
  {
    paramKey: 'ge_endTimestamp',
    searchEngineParamKey: 'ge_endTimestamp',
  },
];
